import { CONST_STICKY_FOOTER_HEIGHT } from './constants'

export const getContainerHeight = (headerHeight: number) => {
  return `calc(100vh - ${headerHeight + CONST_STICKY_FOOTER_HEIGHT}px)`
}
